/**
 * This initializer registers format.js for ember intl formatter to use. Engines do not register
 * files from the root, which is what ember intl expects, so we have to do it manually.
 */
import Formats from '@capital/intl/formats';
export function initialize(application) {
  application.register('formats:main', Formats);
}
export default {
  initialize
};